import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ExitScoringButton = ({ eventId }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const handleExit = () => {
    setOpen(false);
    navigate(`/events/${eventId}/program`);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Are you sure you want to exit scoring?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={handleExit}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Button
        variant='contained'
        color='error'
        sx={{ marginBottom: '4em' }}
        onClick={() => {
          setOpen(true);
        }}
      >
        Exit Scoring
      </Button>
    </>
  );
};

export default ExitScoringButton;
